import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BaseFieldComponent } from '../base-field.component';

@Component({
  selector: 'app-select-field',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  template: `
    <div class="field-wrapper" [class]="field.cssClass" [class.has-error]="isInvalid">

      <label [for]="field.id">{{ field.label }}<a *ngIf="hasLabelLink" [href]="field.linkUrl" [target]="field.linkTarget ?? '_blank'" [attr.rel]="(field.linkTarget ?? '_blank') === '_blank' ? 'noopener noreferrer' : null">{{ field.linkText }}</a></label>

      <select [id]="field.id" [formControl]="control">
        <option [ngValue]="null" disabled>
          {{ field.placeholder ?? 'Seleccione...' }}
        </option>
        <option
          *ngFor="let opt of field.options"
          [value]="opt.value"
          [disabled]="opt.disabled ?? false">
          {{ opt.label }}
        </option>
      </select>

      <small *ngIf="field.hint && !isInvalid && !isPending"
             [id]="field.id + '-hint'">
        {{ field.hint }}
      </small>

      <span *ngIf="isPending" class="field-pending">
        Verificando...
      </span>

      <small *ngIf="isInvalid" class="error">
        {{ errorMessage }}
      </small>

    </div>
  `
})
export class SelectFieldComponent extends BaseFieldComponent {}